/**
 * JWT role strings for the PARA 2.0 shell (`/progress`).
 * Classic GT uses {@link import('@gt/_helpers/roles').Role} (`Teacher`, `Principal`, …).
 */
export enum Role {
	ParaTeacher = 'PARA_Teacher',
	ParaPrincipal = 'PARA_Principal',
	ParaArea = 'PARA_Area',
	ParaAdmin = 'PARA_Admin',
}

/** All PARA shell JWT roles (single source for guards and routing). */
export const PARA_JWT_ROLES: readonly Role[] = [Role.ParaTeacher, Role.ParaPrincipal, Role.ParaArea, Role.ParaAdmin];

/** User-facing labels for JWT role keys (header, profile menu). */
export const PARA_ROLE_DISPLAY_LABELS: Readonly<Record<Role, string>> = {
	[Role.ParaTeacher]: 'Teacher',
	[Role.ParaPrincipal]: 'Principal',
	[Role.ParaArea]: 'Area',
	[Role.ParaAdmin]: 'Admin',
};

export function getParaRoleDisplayLabel(role: string | undefined | null): string {
	if (role == null || role === '') return '';
	if (isParaJwtRole(role)) return PARA_ROLE_DISPLAY_LABELS[role];
	return role;
}

export function isParaJwtRole(role: string | undefined): role is Role {
	return role != null && role !== '' && (PARA_JWT_ROLES as readonly string[]).includes(role);
}
